import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BasefieldV2Component } from '@app/formly/types/v2/basefield-v2/basefield-v2.component';
import { DropdownItem } from '@voyagu/radar-design-system';

@Component({
  selector: 'single-select-field',
  templateUrl: './single-select-field.component.html',
  styleUrls: ['./single-select-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectFieldComponent extends BasefieldV2Component implements OnInit {
  items: DropdownItem[];
  selectedItem: DropdownItem;

  ngOnInit() {
    this.items = this.props.values?.map((v: FilterOption) => this.toDropdownItem(v));

    this.selectedItem = this.items.find((i) => i.value === this.props.initial) as DropdownItem;
  }

  select(selectedItem: DropdownItem) {
    this.selectedItem = selectedItem;

    this.formControl.setValue(selectedItem.value);
    this.formControl.markAsDirty();
  }

  toDropdownItem(option: FilterOption): DropdownItem {
    return {
      label: option.value,
      value: option.key,
      ...(option.picture != null ? { picture: option.picture } : {}),
    };
  }
}

type FilterOption = {
  key: string;
  value: string;
  picture?: string | null;
};
